import strings from 'strings';
import { CandidateEntity, JobOrderEntity } from 'UI/constants/entityTypes';
import { OptionRenderers } from 'UI/utils/renderers';

export const COPIES = strings.ai.generators.roleplay.listPage;

export const COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'recruiterName',
    label: 'Recruiter',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'type',
    label: 'Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'industry',
    label: 'Industry: Specialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'goalsMet',
    label: 'Goals Met',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'durationSeconds',
    label: 'Phone time',
    options: {
      sort: true,
      display: true,
      renderer: 'phoneTime'
    }
  },
  {
    name: 'difficulty',
    label: 'Difficulty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'createdAt',
    label: 'Roleplay Date',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  }
];

export const PAGE_KEY = 'roleplay-list';

export const ORDER_BY_OPTIONS = {
  column: 'createdAt',
  direction: 'desc'
};

export const ROLEPLAY_CALL_TARGET_OPTIONS = [
  {
    id: CandidateEntity.id,
    title: strings.ai.generators.roleplay.form.sections.callTargetOptions.callHiringAuthority.title,
    placeholder:
      strings.ai.generators.roleplay.form.sections.callTargetOptions.callHiringAuthority.label,
    renderOption: OptionRenderers.globalSearchPerson('title', null, null, true)
  },
  {
    id: JobOrderEntity.id,
    title: strings.ai.generators.roleplay.form.sections.callTargetOptions.callCandidate.title,
    placeholder: strings.ai.generators.roleplay.form.sections.callTargetOptions.callCandidate.label,
    renderOption: OptionRenderers.globalSearchDefault('title')
  }
];

export const ROLEPLAY_SETUP_OPTIONS = {
  fromInventory: 'fromInventory',
  manual: 'manual'
};
